<template>
    <div class="box">

        <div class="content">
            <div class="part">


                <!-- 入金2/未达标0/已结束4 -->
                <div
                    :class="(tradeStatus == '' || (tradeStatus == 1 && !qualityStatus) || (!qualityStatus1 && tradeStatus == 2)) ? 'part1 parts' : 'part1'">

                    <div class="tops">
                        <div class="tops-cont flex">
                            <div class="flex1">
                                <p><span class="limit">${{ activeInfo.depositamount || '--' }}</span></p>
                                <p class="number">—— 净入金 ——</p>
                            </div>
                            <div class="flex1">
                                <p><span class="limit">${{ activeInfo.profitloss || '--' }}</span></p>
                                <p class="number">—— 我的盈亏 ——</p>
                            </div>
                        </div>
                        <div class="grade">
                            <div v-for="(item, index) in gradeList" :key="index"
                                :class="activeIndex == index && tradeStatus != 5 ? 'active' : index != 2 ? 'active-border' : ''">

                                <img :src="item.img" class="icon" alt="">
                                <span :class="activeIndex == index ? 'active-num' : ''">
                                    <span v-if="item.lable != 0">{{
                                        '$' + item.lable + '赠金' + '+' }}</span>
                                    <span v-if="item.lables != 0">{{
                                        '$' + item.lables + '现金' }}</span></span>
                                <img v-if="tradeStatus == 3 && activeIndex == index" class="icons"
                                    src="/activity/Millionsubsidy/function/pending.png" alt="">
                                <img v-if="tradeStatus == 4 && activeIndex == index" class="icons"
                                    src="/activity/Millionsubsidy/function/finish.png" alt="">

                            </div>

                        </div>
                        <img class="boxs"
                            v-if="(tradeStatus == '' || (tradeStatus == 1 && !qualityStatus) || (!qualityStatus1 && tradeStatus == 2))"
                            @click="toTrade()" src="/activity/Millionsubsidy/function/button.png" alt="">
                        <img class="boxs" v-else @click="toDeal" src="/activity/Millionsubsidy/function/button1.png"
                            alt="">
                        <p class="tips"
                            v-if="(tradeStatus == '' || (tradeStatus == 1 && !qualityStatus) || (!qualityStatus1 && tradeStatus == 2))">
                            新户入金≥{{ minamount }}美金 方可激活7日险权益</p>

                    </div>
                    <div class="bottoms">
                        <div class="times timess">
                            <span class="time">{{ day }}</span>
                            <span class="time">{{ hour }}</span>
                            <span class="time">{{ minute }}</span>
                            <span class="time">{{ second }}</span>
                        </div>

                    </div>
                </div>
                <div class="wappart2 clearfix" v-if="activeInfo.rule">
                    <ul class="dialogContent" style="font-size: 14px;" v-html="activeInfo.rule"></ul>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import userSign from '@/mixins/userSign';
import { setToken, getToken, deleteToken } from "../../../../utils/cookies.js";
import { appLy, sendTicket, usercenter } from '@/apis/active';
import { getConfigurationValue } from '@/apis/common'
import { getCompensate } from '@/apis/transfer'
import { encryptCBC } from "../../../../utils/IMEI";

export default {
    mixins: [userSign],
    data() {
        return {

            scroll: "",
            timer: null,
            isApp: false,
            day: '--',
            hour: '--',
            minute: '--',
            second: '--',
            curStartTime: '',//结束时间
            userinfo: {},
            isLogin: false,//App端是否有Token
            queryInfo: {},//传递数据
            activeIndex: '',
            gradeList: [
                {
                    img: '/activity/Millionsubsidy/function/icon.png',
                    lable: '',
                    lables: ''
                },
                {
                    img: '/activity/Millionsubsidy/function/icon1.png',
                    lable: '',
                    lables: ''
                },
                {
                    img: '/activity/Millionsubsidy/function/icon2.png',
                    lable: '',
                    lables: ''
                },
            ],
            tradeStatus: '',//入金状态
            activeInfo: {},//活动信息
            minamount: '',//起赔标准
            qualityStatus: false,//是否符合标准
            qualityStatus1: false,//未达标

        };
    },

    mounted() {

    },
    destroyed() {
        clearInterval(this.timer);
    },
    watch: {},
    created() {
        // 关闭头部导航和底部导航
        this.$emit('controlShow', true);
        // 判断是否是App登录进来
        if (this.$route.query.from) {
            const queryData = this.$route.query;
            this.queryInfo = this.$route.query;
            const { accessKey = '', from = '' } = queryData;
            if (from === 'app_pm') {
                this.isApp = true;
            }
            console.log('App数据----------', queryData)
            if (accessKey) {
                setToken(accessKey)
            }
            if (from === 'app_pm' && !accessKey) {
                deleteToken();
            }
            const token = getToken();
            console.log('token', token)
            if (token) {
                this.isLogin = true
                localStorage.setItem('account', this.$route.query.a);
                this.userKey = localStorage.getItem('token');
                this.getActiveinfo()

            } else {
                this.isLogin = false
                this.toLogin()
            }
        }

    },
    methods: {
        getActiveinfo() {
            let params = {
                accountid: localStorage.getItem('account'),
                platform: 1
            }
            const iv = 'LIQABxPFN04DhnkX';
            getCompensate('paidUrl', { data: encryptCBC(JSON.stringify(params), 'Uk6pqN80hgFbbC7a', iv), iv }).then(res => {
                console.log('请求数据------', res)
                if (res.status == 0) {
                    let data = res.content.accountInfo
                    let datas = res.content.activityCfg
                    this.activeInfo = data
                    this.activeInfo.rule = this.activeInfo.rule.replace(/img/gi,'img style="width: 100%"')
                    this.activeInfo.rule = this.activeInfo.rule.replace(
                        /<span\s+style\s*=\s*(["'])[^"']*text-wrap-mode\s*:\s*nowrap;?[^"']*\1\s*>/gi,
                        `<span style="white-space: wrap;">`
                      )
                    this.minamount = res.content.minamount ? res.content.minamount : ''
                    let level = data.level
                    let status = data.status
                    console.log('lecel----', level)
                    this.activeIndex = level ? level == 'A1' ? 0 : level == 'A2' ? 1 : level == 'A3' ? 2 : 4 : 4
                    // 结束时间保障用expirationtime,其余用depositstarttime
                    this.curStartTime = data.expirationtime

                    // （1：未到期，2：未达标，3：待赔付，4：已赔付，5：已作废）
                    // 如果未到期且时间到了净入金小于赔付标准时间--如果大于前往入金总入金
                    if (status == 1) {
                        // 
                        const today = new Date()
                        const endOfMonth = new Date(data.depositendtime + 8 * 3600000).getTime();
                        console.log('时间----', endOfMonth - today)
                        if ((endOfMonth - today < 0)) {
                            this.curStartTime = data.expirationtime
                            this.qualityStatus = true
                            this.updateCountdown()
                            setInterval(this.updateCountdown, 1000);
                        } else {
                            this.curStartTime = data.depositendtime

                            this.qualityStatus = false
                        }

                    }
                    // 如果状态为2且时间到了；
                    if (status == 2) {
                        // 如果净入金大于赔付标准时间
                        if (data.depositamount > this.minamount) {
                            this.qualityStatus1 = true
                        } else {
                            this.qualityStatus1 = false
                        }

                    }
                    this.tradeStatus = status ? status : ''
                    datas.map((item, index) => {
                        this.gradeList[index].lable = item.givegoldpoint ? item.givegoldpoint : 0
                        this.gradeList[index].lables = item.amount ? item.amount : 0
                    })
                    console.log('时间-----', this.getDateChange(data.depositendtime), this.qualityStatus1, '未达标', this.tradeStatus == 2)
                    // 不为空（未参加）未达标状态为1；
                    if ((this.qualityStatus1 && this.tradeStatus == 2) || (this.tradeStatus != '' && !this.qualityStatus1 && !this.qualityStatus && this.tradeStatus != 2)) {
                        this.updateCountdown()
                        setInterval(this.updateCountdown, 1000);
                    }


                } else {
                    
                    this.$message({
                        message: res.message,
                        type: 'warning',
                    });
                }
            })
        },
        async getTradeWapLink() {

            try {
                const res = await getConfigurationValue({ key: 'H5LinkMT5' });
                const defaultLink = 'https://h5pro.rlc561.com';
                if (res) {
                    return res
                } else {
                    return defaultLink
                }
            } catch (e) {
                return defaultLink
            }
        },
        // app登录
        toLogin() {
            // 在安卓app
            if (window.android) {
                window.android.gotoLogin();
                return
            }
            // 在ios
            if (window.webkit) {
                window.webkit.messageHandlers.gotoLogin()
                return
            }
            if (window.ReactNativeWebView) {
                const message = JSON.stringify({ method: 'gotoLogin', data: '' });
                window.ReactNativeWebView.postMessage(message);
                return
            }
        },
        // 去入金
        async toTrade() {
            // 在安卓app
            if (window.android) {
                window.android.gotoDeposit();
                return
            }
            // 在ios
            if (window.webkit) {
                window.webkit.messageHandlers.gotoDeposit.postMessage('1');
                return
            }
            if (window.ReactNativeWebView) {
                const message = JSON.stringify({ method: 'gotoDeposit', data: '' });
                window.ReactNativeWebView.postMessage(message);
                return
            }
            // 在网页浏览器
            const h5LinkUrl = await this.getTradeWapLink();
            const sendData = {
                token: getToken(),
                userStatus: 3,
            }
            window.open(this.queryInfo.fromUrl + '/assets/deposit');
        },
        // 去交易
        async toDeal() {
            // 在安卓app
            if (window.android) {
                window.android.gotoTrade();
                return
            }
            // 在ios
            if (window.webkit) {
                window.webkit.messageHandlers.gotoTrade.postMessage('1');
                return
            }
            if (window.ReactNativeWebView) {
                const message = JSON.stringify({ method: 'gotoTrade', data: '' });
                window.ReactNativeWebView.postMessage(message);
                return
            }
            // 在网页浏览器
            const h5LinkUrl = await this.getTradeWapLink();
            const sendData = {
                token: getToken(),
                userStatus: 3,
            }
            window.open(this.queryInfo.fromUrl + '/home/quote');
        },

        // 倒计时
        updateCountdown() {
            // const today = new Date();

            const today = new Date()

            const endOfMonth = new Date(this.curStartTime + 8 * 3600000).getTime();
            // console.log(endOfMonth,today)
            let timeLeft = endOfMonth - today;
            if (timeLeft <= 0) {
                timeLeft = 0;
                clearInterval(this.timer);
            }
            this.day = String(Math.floor(timeLeft / (1000 * 60 * 60 * 24))).padStart(
                2,
                "0"
            );
            this.hour = String(
                Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
            ).padStart(2, "0");
            this.minute = String(
                Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))
            ).padStart(2, "0");
            this.second = String(
                Math.floor((timeLeft % (1000 * 60)) / 1000)
            ).padStart(2, "0");
        },



        // 计算时间差值
        constdiffInDays(date1, date2) {


            const data2 = new Date().getTime()
            const data1 = new Date(date1 + 8 * 3600000).getTime();
            console.log(this.getDateChange(data1), this.getDateChange(data2))
            let data = (data2 - data1)
            return Math.floor(data / (24 * 3600 * 1000))


        },
        // 时间戳转时间
        getDateChange(date) {
            var t = new Date(date).toLocaleString();
            return t;
        },

    },


};
</script>

<style lang="less" scoped>
.box {
    width: 20%;
    margin: 0 auto;



    .tps {
        position: absolute;
        top: 81%;
        left: 24%;
    }

  .times {

      padding: 10px 20px 20px 00px;
      box-sizing: border-box;
      height: auto;
      width: 89%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;

      span {
          line-height: 43px;
          font-size: 12px;
          font-weight: 700;
          color: #f54937;
          // margin-right: 12px;

      }

      .time {
          font-size: 30px;
          display: flex;
          align-items: baseline;
      }


  }





  .content {
      width: 100%;
      height: auto;
      // height: 5627px;
      box-sizing: border-box;
      margin: 0 auto;

      background: url(/activity/Millionsubsidy/function/bg.png) no-repeat;
      background-size: 100% 100%;



      .part {
          // max-width: 1400px;
          width: 94%;
          margin: 0 auto;
          padding: 4% 2% 10%;

          .part1 {
              box-sizing: border-box;


              padding: 10% 4% 10%;

              background: url(/activity/Millionsubsidy/function/aliderbg.png) no-repeat center center;
              background-size: 100% 100%;
              margin: 0 auto;
              display: block;
              position: relative;



              .flex {
                  display: flex;
                  justify-content: center;
                  align-items: center;
              }

              .flex1 {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
              }

              .tops {
                  padding: 20px 0 80px;

                  &-cont {


                      div {
                          width: 136px;
                          height: 71px;




                          p {
                              font-size: 12px;

                              color: #ff270a;
                          }

                          .limit {
                              font-size: 32px;
                              font-weight: 600;

                          }

                          .number {
                              color: #7f2815;
                              font-weight: 500;
                          }
                      }

                  }

                  .grade {
                      background: #fff;
                      display: flex;
                      flex-direction: column;
                      margin-top: 50px;

                      div {
                          display: flex;
                          align-items: center;

                          padding: 4px 0 4px 30px;

                          .icon {
                              width: 36px;
                              height: 40px;
                              margin-right: 10px;
                          }

                          .icons {
                              width: 60px;
                              height: auto;
                              margin-left: 30px;
                          }

                          font-size: 16px;
                          color: #000;
                          font-weight: 600;
                      }

                      .active-border {
                          border-bottom: 1px solid #ccc;
                      }

                      .active {
                          background: url(/activity/Millionsubsidy/function/bg1.png) no-repeat center;
                          background-size: 100% 100%;
                          border-radius: 10px;
                      }

                      .active-num {
                          // color: #fffcab;
                      }
                  }



                  .boxs {
                      width: 100%;
                      margin-top: 20px;
                  }
              }

              .bottoms {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  position: relative;
                  padding-top: 20px;

                  .tit {
                      color: #FE5905;
                      font-size: 16px;
                      font-weight: 600;
                      position: absolute;
                      top: -70%;
                      left: 30%;
                  }

                  .tits {
                      font-size: 13px;
                      color: #FF8314;
                      position: absolute;
                      top: -20%;
                      left: 20%;

                  }

                  img {
                      width: 100%;
                  }
              }

          }

          .parts {
              background: url(/activity/Millionsubsidy/function/qualified.png) no-repeat center center;
              background-size: 100% 100%;
          }

          .tips {
              color: #000;
              font-size: 14px;
              font-weight: 600;
              margin: 0;
              text-align: center;
          }



          .wappart2 {

              display: block;
              margin: 0 auto;
              margin-top: 30px;
              padding: 1% 6% 10%;
              background: url(/activity/Millionsubsidy/function/bg2.png) no-repeat center;
              background-size: 100% 100%;
              background-position: center;
              box-sizing: border-box;

              /* 填充整个小div */
              .clearfix::after {
                  content: "";
                  display: table;
                  clear: both;
              }

              h3 {
                  color: #d88f4f;
                  text-align: center;
                  font-size: 12px;
              }

              li {
                  font-size: 12px;
                  color: #000;
                  font-weight: 500;
                  line-height: 34px;

                  span {
                      font-weight: 600;
                      color: #ff4f10;
                  }

                  .example {
                      color: #1665f5;
                      font-weight: 600;
                  }

                  .font {
                      color: #000;
                      font-weight: 600;
                  }

                  img {
                      width: 100%;
                      height: auto;
                      margin: 20px 0;
                  }

                  table {
                      margin: 20px 0;
                      width: 100%;
                      border: 1px solid #464646;
                      border-radius: 10px;

                      tr {
                          th {
                              text-align: center;
                              font-weight: 500;
                              line-height: 24px;
                              border-bottom: 1px solid #464646;
                              border-right: 1px solid #464646;
                              padding: 5px;
                          }

                          th:last-child {}
                      }

                      tr:nth-child(1) {
                          th {
                              font-weight: 600;
                          }
                      }
                  }
              }





          }


      }
  }


}




@media screen and (max-width: 500px) {
    .box {
        width: 100%;

        .banner {
            width: 100%;


            // padding-top: 75px;
        }





        .times {

            padding: 10px 20px 20px 00px;
            box-sizing: border-box;
            height: auto;
            width: 89%;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;

            span {
                line-height: 43px;
                font-size: 12px;
                font-weight: 700;
                color: #f54937;
                // margin-right: 12px;

            }

            .time {
                font-size: 30px;
                display: flex;
                align-items: baseline;
            }


        }





        .content {
            width: 100%;
            height: auto;
            // height: 5627px;
            box-sizing: border-box;
            margin: 0 auto;

            background: url(/activity/Millionsubsidy/function/bg.png) no-repeat;
            background-size: 100% 100%;



            .part {
                // max-width: 1400px;
                width: 94%;
                margin: 0 auto;
                padding: 4% 2% 10%;

                .part1 {
                    box-sizing: border-box;


                    padding: 10% 4% 10%;

                    background: url(/activity/Millionsubsidy/function/aliderbg.png) no-repeat center center;
                    background-size: 100% 100%;
                    margin: 0 auto;
                    display: block;
                    position: relative;



                    .flex {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    .flex1 {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }

                    .tops {
                        padding: 20px 0 80px;

                        &-cont {


                            div {
                                width: 136px;
                                height: 71px;




                                p {
                                    font-size: 12px;

                                    color: #ff270a;
                                }

                                .limit {
                                    font-size: 32px;
                                    font-weight: 600;

                                }

                                .number {
                                    color: #7f2815;
                                    font-weight: 500;
                                }
                            }

                        }

                        .grade {
                            background: #fff;
                            display: flex;
                            flex-direction: column;
                            margin-top: 50px;

                            div {
                                display: flex;
                                align-items: center;

                                padding: 4px 0 4px 30px;

                                .icon {
                                    width: 36px;
                                    height: 40px;
                                    margin-right: 10px;
                                }

                                .icons {
                                    width: 60px;
                                    height: auto;
                                    margin-left: 30px;
                                }

                                font-size: 16px;
                                color: #000;
                                font-weight: 600;
                            }

                            .active-border {
                                border-bottom: 1px solid #ccc;
                            }

                            .active {
                                background: url(/activity/Millionsubsidy/function/bg1.png) no-repeat center;
                                background-size: 100% 100%;
                                border-radius: 10px;
                            }

                            .active-num {
                                // color: #fffcab;
                            }
                        }



                        .boxs {
                            width: 100%;
                            margin-top: 20px;
                        }
                    }

                    .bottoms {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        position: relative;
                        padding-top: 20px;

                        .tit {
                            color: #FE5905;
                            font-size: 16px;
                            font-weight: 600;
                            position: absolute;
                            top: -70%;
                            left: 30%;
                        }

                        .tits {
                            font-size: 13px;
                            color: #FF8314;
                            position: absolute;
                            top: -20%;
                            left: 20%;

                        }

                        img {
                            width: 100%;
                        }
                    }

                }

                .parts {
                    background: url(/activity/Millionsubsidy/function/qualified.png) no-repeat center center;
                    background-size: 100% 100%;
                }

                .tips {
                    color: #000;
                    font-size: 14px;
                    font-weight: 600;
                    margin: 0;
                    text-align: center;
                }



                .wappart2 {

                    display: block;
                    margin: 0 auto;
                    margin-top: 30px;
                    padding: 1% 6% 10%;
                    background: url(/activity/Millionsubsidy/function/bg2.png) no-repeat center;
                    background-size: 100% 100%;
                    background-position: center;
                    box-sizing: border-box;

                    /* 填充整个小div */
                    .clearfix::after {
                        content: "";
                        display: table;
                        clear: both;
                    }

                    h3 {
                        color: #d88f4f;
                        text-align: center;
                        font-size: 12px;
                    }

                    li {
                        font-size: 12px;
                        color: #000;
                        font-weight: 500;
                        line-height: 34px;

                        span {
                            font-weight: 600;
                            color: #ff4f10;
                        }

                        .example {
                            color: #1665f5;
                            font-weight: 600;
                        }

                        .font {
                            color: #000;
                            font-weight: 600;
                        }

                        img {
                            width: 100%;
                            height: auto;
                            margin: 20px 0;
                        }

                        table {
                            margin: 20px 0;
                            width: 100%;
                            border: 1px solid #464646;
                            border-radius: 10px;

                            tr {
                                th {
                                    text-align: center;
                                    font-weight: 500;
                                    line-height: 24px;
                                    border-bottom: 1px solid #464646;
                                    border-right: 1px solid #464646;
                                    padding: 5px;
                                }

                                th:last-child {}
                            }

                            tr:nth-child(1) {
                                th {
                                    font-weight: 600;
                                }
                            }
                        }
                    }





                }


            }
        }

    }

}
</style>
